<div class="container">
  <!-- <div class="spinner-loader" *ngIf="loading">
      <mat-spinner class="center" ></mat-spinner>
    </div> -->

  <div>
    <ng-container *ngIf="breadCrumb$ | async as breadCrumb">
      <bread-crumb [breadCrumb]="breadCrumb"></bread-crumb>
    </ng-container>

    <div class="row full-width">
      <div class="row-inner">
        <mat-form-field appearance="outline">
          <mat-label>Search students</mat-label>
          <input [formControl]='searchText' matInput class="form-control">
        </mat-form-field>
        <button routerLink="/people/students/create" mat-button class="create-button standard-button full-width m-t-5">
          <mat-icon>add</mat-icon>
          <span class="title"><strong><small>Create Leaner</small></strong></span>
        </button>
      </div>
    </div>



    <div class="table-contianer">
      <h6 style="opacity: 0.6;">Please select a leaner to modify their details. </h6>
      <table mat-table [dataSource]="dataSource" matSort class="full-width">
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef> <strong>Title</strong> </th>
          <td mat-cell *matCellDef="let element"> <strong><small>{{element.title}}</small></strong> </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.initials + " " + element.lastName}} </td>
        </ng-container>
        <ng-container matColumnDef="gender">
          <th mat-header-cell *matHeaderCellDef> Gender </th>
          <td mat-cell *matCellDef="let element"> {{element.gender}} </td>
        </ng-container>
        <ng-container matColumnDef="identificationNumber">
          <th mat-header-cell *matHeaderCellDef> ID.no </th>
          <td mat-cell *matCellDef="let element"> {{element.identificationNumber}} </td>
        </ng-container>
        <ng-container matColumnDef="verified">
          <th mat-header-cell *matHeaderCellDef> Verification </th>
          <td mat-cell *matCellDef="let element"> {{element.verified ? 'Verified' : 'Not Verified'}} </td>
        </ng-container>

        <tr class="mat-row" *matNoDataRow [ngClass]="{hidden: loadingPageResults != false}">
          <td class="mat-cell text-center" colspan="999">No Results Found
          </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="openUser(row)"></tr>
      </table>

      <ng-container *ngIf="loadingPageResults">
        <div class='table-loader'>
          <mat-spinner class='center'></mat-spinner>
        </div>
      </ng-container>
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="dataResult?.collectionSize"></mat-paginator>
    </div>


  </div>
</div>